<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-code-block`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.355 2.785H15.89c-1.98 0-3.51.63-4.59 1.935-.99 1.17-1.485 2.79-1.485 4.815v8.415c0 1.26-.27 2.205-.81 2.835-.519.556-1.374.929-2.565 1.093-.454.063-.81.432-.81.891v2.098c0 .438.34.792.775.847 1.21.152 2.076.502 2.6 1.101.54.585.81 1.53.81 2.835v8.46c0 1.98.495 3.6 1.485 4.77 1.08 1.26 2.61 1.935 4.59 1.935h2.465a1 1 0 001-1V42.17a1 1 0 00-1-1H16.7c-1.71 0-2.52-.99-2.52-2.88v-8.865c0-2.7-1.305-4.545-3.87-5.625 2.565-.945 3.87-2.835 3.87-5.625v-8.82c0-1.98.81-2.925 2.52-2.925h1.655a1 1 0 001-1V3.785a1 1 0 00-1-1zm11.245 0a1 1 0 00-1 1V5.43a1 1 0 001 1h1.655c1.665 0 2.52.945 2.52 2.925v8.82c0 2.79 1.26 4.68 3.87 5.625-2.61 1.08-3.87 2.925-3.87 5.625v8.865c0 1.89-.855 2.88-2.52 2.88H29.6a1 1 0 00-1 1v1.645a1 1 0 001 1h2.465c1.98 0 3.51-.675 4.59-1.935.99-1.17 1.485-2.79 1.485-4.77v-8.46c0-1.305.27-2.25.81-2.835.508-.58 1.338-.927 2.49-1.087.496-.069.885-.47.885-.972v-1.972c0-.467-.362-.843-.826-.908-1.181-.164-2.024-.53-2.504-1.046-.585-.63-.855-1.62-.855-2.88V9.535c0-2.025-.495-3.645-1.485-4.815-1.08-1.305-2.61-1.935-4.59-1.935H29.6z"/></svg>
</template>
<script>

export default {
  name: 'IconCodeBlock',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
